<template>
  <v-col class="background">
    <v-row>
      <v-col class="text-center">
        <img :src="logo" alt="logo" class="lucky-logo" />
      </v-col>
      <v-col class="text-center big">
        <span>Winning Numbers</span>
      </v-col>
      <v-col class="text-center">
        <img :src="logo" alt="logo" class="lucky-logo" />
      </v-col>
    </v-row>
    <v-row v-for="number in result.numbers" :key="number.playType.id">
      <v-col class="text-center" cols="4">
        <img
          :src="imageForPlayType(number.playType)"
          alt="playType"
          class="pick"
        />
      </v-col>
      <v-col cols="8">
        <img
          v-for="(result, index) in number.digits"
          :key="index"
          :src="fieryBalls[parseInt(result, 10)]"
          alt="result"
          class="ball"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ResultField from "../../../../enumerations/ResultField.json";
import logo from "../../../../assets/img/quicklotto/logo.png";
import fiery0 from "./images/C0.png";
import fiery1 from "./images/C1.png";
import fiery2 from "./images/C2.png";
import fiery3 from "./images/C3.png";
import fiery4 from "./images/C4.png";
import fiery5 from "./images/C5.png";
import fiery6 from "./images/C6.png";
import fiery7 from "./images/C7.png";
import fiery8 from "./images/C8.png";
import fiery9 from "./images/C9.png";

import pick2 from "./images/pick2.png";
import pick3 from "./images/pick3.png";
import pick4 from "./images/pick4.png";
import pick5 from "./images/pick5.png";

export default {
  name: "WinningNumbers",
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      logo,
      fieryBalls: [
        fiery0,
        fiery1,
        fiery2,
        fiery3,
        fiery4,
        fiery5,
        fiery6,
        fiery7,
        fiery8,
        fiery9
      ]
    };
  },
  mounted() {
    this.$confetti.start();
  },
  destroyed() {
    this.$confetti.stop();
  },
  methods: {
    imageForPlayType(playType) {
      switch (playType.id) {
        case ResultField.PickTwo:
          return pick2;
        case ResultField.CashThree:
          return pick3;
        case ResultField.PickFour:
          return pick4;
        case ResultField.PickFive:
          return pick5;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-height: 130px;
}

.big {
  font-size: 2.5em;
	color: white;
}

img.lucky-logo {
  max-height: 100px;
}

img.winning-numbers {
  max-height: 200px;
}
</style>
